import React from 'react';

import YatCollectionShelfItem from './Item/Item';
import './YatCollectionShelf.scss';

interface YatCheckoutItem {
    yat: string;
    rhythmScore: number;
    price: number;
    taken: boolean;
}

interface YatCollectionShelfProps {
    yats: YatCheckoutItem[];
    large?: boolean;
    orderItemIds: string[];
}

export const YatCollectionShelf = ({ yats, large = false, orderItemIds }: YatCollectionShelfProps) => {
    return (
        <div className="yat-collection-shelf">
            <div className="yat-collection-shelf__backdrop-glow" />
            <div className="yat-collection-shelf__shelf" />
            <div className="yat-collection-shelf__item-container">
                {yats.map((yat, i) => (
                    <YatCollectionShelfItem
                        key={orderItemIds[i]}
                        yat={yat.yat}
                        price={yat.price}
                        rhythmScore={yat.rhythmScore}
                        large={large}
                        orderItemId={orderItemIds[i]}
                        taken={yat.taken}
                    />
                ))}
            </div>
        </div>
    );
};
